import { api } from './api';
import type { PlanFeatureItem, SetPlanFeaturesRequest } from '../types/planFeature';

class PlanFeatureService {
  async getByPlanId(planId: string): Promise<PlanFeatureItem[]> {
    const response = await api.get<PlanFeatureItem[]>(`/plans/${planId}/features`);
    return response.data;
  }

  async setPlanFeatures(planId: string, payload: SetPlanFeaturesRequest): Promise<PlanFeatureItem[]> {
    const response = await api.put<PlanFeatureItem[]>(`/plans/${planId}/features`, payload);
    return response.data;
  }
}

export const planFeatureService = new PlanFeatureService();
